import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    maxLength
} from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "jobRequestEdit",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            jobRequestForm: {
                job_request_title: '',
                job_request_details: ''
            },
            submitted: false,
        };
    },

    validations: {
        jobRequestForm: {
            job_request_title: {
                required,
                maxLength: maxLength(100)
            },
            job_request_details: {
                required,
                maxLength: maxLength(1000)
            }
        }
    },

    methods: {
        showJobRequestUpdate() {
            axios.get("applicant/job_request/detail/" + this.$route.params.id)
                .then(response => {
                    this.jobRequestForm = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        submitJobRequest() {
            this.submitted = true;
            if (this.$v.jobRequestForm.$invalid) {
                return;
            }
            this.updateJobRequest();
        },

        updateJobRequest() {
            this.isLoading = true;
            var request = {
                id: this.$route.params.id,
                job_request_title: this.jobRequestForm.job_request_title,
                job_request_details: this.jobRequestForm.job_request_details
            };
            axios.post("/applicant/job_request/update", request)
                .then(() => {
                    this.$notification.success("ပိုစ့် တင်ပြီးပါပြီ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    this.$router.push({
                        name: 'jobRequestDetail',
                        params: { id: request.id }
                    });
                })
                .catch(error => {
                    console.log("Job Request Update Error", error);
                });
        }
    },
    mounted() {
        this.showJobRequestUpdate();
    }
};